import { lazy, Suspense } from "react";
import type { FC } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./i18n";

// Lazy-loaded components
const HomeMain = lazy(() => import("./pages/home/HomeMain"));
const ProjectsMain = lazy(() => import("./pages/projects/ProjectsMain"));
const CustomizeSolution = lazy(() => import("./pages/customize-solution/CustomizeSolution"));
const Innovation = lazy(() => import("./pages/innovation-in-agriculture/Innovation"));
const PolyCarbonateD = lazy(() => import("./pages/projects/PolyCarbonateD"));
const ScreenHouseD = lazy(() => import("./pages/projects/ScreenHouseD"));
const PolythenD = lazy(() => import("./pages/projects/PolythenD"));
const HydroponicsD = lazy(() => import("./pages/projects/HydroponicsD"));
const BlogDetail = lazy(() => import("./pages/Blog/BlogDetail"));

import ScrollToTop from "./components/ScrollToTop";
import RouteSeo from "./components/RouteSeo";
import NewNav from "./components/NewNav";
import NewFooter from "./components/NewFooter";

import { Researchmain } from "./pages/research/Researchmain";
import { Contactmain } from "./Contact/Contactmain";
import { Blogmain } from "./pages/Blog/Blogmain";
import { TurnKeyProjects } from "./pages/turnkey/TurnKeyProjects";
import { Automationmain } from "./pages/automation/Automationmain";
import Portfoliomain from "./pages/portfolio/Portfoliomain";
import Fertigationmain from "./pages/fertigation/Fertigationmain";
import GreenHouseImproved from "./pages/projects/GreenHouseD";

const App: FC = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <RouteSeo />

      {/* ✅ Wrap EVERYTHING */}
      <Suspense
        fallback={
          <div className="flex justify-center items-center h-screen">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-green-500"></div>
          </div>
        }
      >
        <NewNav />

        <main role="main">
          <Routes>
            <Route path="/" element={<HomeMain />} />

            <Route path="/automation-detail" element={<Automationmain />} />
            <Route path="/research-detail" element={<Researchmain />} />
            <Route path="/portfolio" element={<Portfoliomain />} />

            <Route path="/projects" element={<ProjectsMain />} />
            <Route path="/projects-detail" element={<ProjectsMain />} />

            <Route path="/customize-solution" element={<CustomizeSolution />} />
            <Route path="/quality-detail" element={<Innovation />} />

            <Route path="/fertigation-systems" element={<Fertigationmain />} />
            <Route path="/turnkey-projects" element={<TurnKeyProjects />} />

            <Route path="/green-house" element={<GreenHouseImproved />} />
            <Route path="/polycarbonate" element={<PolyCarbonateD />} />
            <Route path="/screen-house" element={<ScreenHouseD />} />
            <Route path="/polythene" element={<PolythenD />} />
            <Route path="/hydroponics" element={<HydroponicsD />} />

            <Route path="/contact" element={<Contactmain />} />
            <Route path="/blog" element={<Blogmain />} />
            <Route path="/blogs/:slug" element={<BlogDetail />} />
          </Routes>
        </main>

        <NewFooter />
      </Suspense>
    </BrowserRouter>
  );
};

export default App;